import { logUsage } from 'owa-analytics';
import {
    RelevanceRelationship,
    InsightsDataFetchSource,
    convertInsightsEntrySourceEnumToName,
} from 'owa-meeting-insights-types-and-flights';
import {
    logInsightsSearchFeedback,
    logInsightsSearchActions,
} from 'owa-meeting-insights/lib/helpers/insightsEventsHelpers';

/**
 * Log the datapoint if user clicks on related file feedback button
 * @param meetingId of the event
 * @param isUseful whether it is 'This is useful' button
 * @param traceId from 3S response
 * @param referenceId of each related file from 3S response
 * @param isOrganizer whether a user is an organizer
 * @param relevanceRelationship whether it is an explicit or implicit suggestion
 * @param entrySource where insights are shown
 */

export function logFileFeedbackButtonClicked(
    meetingId: string,
    isUseful: boolean,
    traceId: string,
    referenceId: string,
    isOrganizer: boolean,
    relevanceRelationship: RelevanceRelationship,
    entrySource: InsightsDataFetchSource
) {
    logUsage(
        'RelatedContentFileFeedbackButtonClicked',
        {
            isUseful: isUseful,
            isOrganizer: isOrganizer,
            relevanceRelationship: relevanceRelationship,
            traceId: traceId,
            referenceId: referenceId,
            entrySource: convertInsightsEntrySourceEnumToName(entrySource),
        },
        { isCore: true }
    );

    logInsightsSearchFeedback(meetingId, traceId, referenceId, isUseful, entrySource);
}

/**
 * Log the datapoint if user clicks on related email feedback button
 * @param meetingId of the event
 * @param isUseful whether it is 'This is useful' button
 * @param traceId from 3S response
 * @param referenceId of each related file from 3S response
 * @param isOrganizer whether a user is an organizer
 * @param relevanceRelationship whether it is an explicit or implicit suggestion
 * @param entrySource where insights are shown
 */
export function logEmailFeedbackButtonClicked(
    meetingId: string,
    isUseful: boolean,
    traceId: string,
    referenceId: string,
    isOrganizer: boolean,
    relevanceRelationship: RelevanceRelationship,
    entrySource: InsightsDataFetchSource
) {
    logUsage(
        'RelatedContentEmailFeedbackButtonClicked',
        {
            isUseful: isUseful,
            isOrganizer: isOrganizer,
            relevanceRelationship: relevanceRelationship,
            traceId: traceId,
            referenceId: referenceId,
            entrySource: convertInsightsEntrySourceEnumToName(entrySource),
        },
        { isCore: true }
    );

    logInsightsSearchFeedback(meetingId, traceId, referenceId, isUseful, entrySource);
}

export function logSeeMoreFilesClicked(
    traceId: string,
    meetingId: string,
    entrySource: InsightsDataFetchSource
) {
    logUsage(
        'RelatedContentSeeMoreFilesClicked',
        {
            traceId,
            entrySource: convertInsightsEntrySourceEnumToName(entrySource),
        },
        { isCore: true }
    );
    logInsightsSearchActions(meetingId, entrySource);
}

export function logSeeMoreEmailsClicked(
    traceId: string,
    meetingId: string,
    entrySource: InsightsDataFetchSource
) {
    logUsage(
        'RelatedContentSeeMoreEmailsClicked',
        {
            traceId,
            entrySource: convertInsightsEntrySourceEnumToName(entrySource),
        },
        { isCore: true }
    );
    logInsightsSearchActions(meetingId, entrySource);
}

export function logMeetingInsightsButtonClicked(traceId: string) {
    logUsage('RelatedContentMeetingInsightsButtonClicked', { traceId });
}

export function logJumpToMeetingInsightsButtonShown() {
    logUsage('RelatedContentJumpToMeetingInsightsButtonShown');
}
